// extracted by mini-css-extract-plugin
export default {"btn":"Main_btn__ra-SH","wrap":"Main_wrap__MqPlA"};